"use client";

import { createContext, useContext, type ReactNode } from "react";

const LandingContext = createContext(false);

/**
 * Markiert einen Teilbaum, in dem Galerien und Karten ein Modal oeffnen statt
 * zu navigieren — genutzt vom `(landing)`-Layout, wo das fuer jede Route gilt.
 *
 * Das sind die Werbeseiten unter `/lead/*`. Wer ueber eine Anzeige kommt, soll
 * nicht ueber einen Artikel- oder Event-Link aus dem Trichter fallen.
 *
 * `/membership` folgte bis August derselben Regel. Zurueckgenommen: Die
 * Kaufseite ist Teil der regulaeren Website, ihre Links sollen navigieren.
 */
export function LandingProvider({ children }: { children: ReactNode }) {
  return (
    <LandingContext.Provider value={true}>
      {children}
    </LandingContext.Provider>
  );
}

export function useIsLandingPage() {
  return useContext(LandingContext);
}
